const pieChart = {
  chartOptions: {
    labels: ["Initiated", "Processing", "Shipped", "Delivered", "Canceled"],
    colors: ["#48BEEA", "#E33065", "#331435", "#65CD54", "red"],
    legend: {
      show: true,
      position: "right",
      verticalAlign: "middle",
      horezintalAlign: "center",
      floating: false,
      fontSize: "13px",
      offsetY: 80,
      offsetX: 20,
      formatter: function (seriesName, opts) {
        return [seriesName, " : ", opts.w.globals.series[opts.seriesIndex]];
      },
      markers: {
        radius: 0,
      },
      itemMargin: {
        vertical: 3,
      },
      stroke: {
        show: true,
        curve: "smooth",
        colors: "#fff",
      },
    },
    title: {
      text: "Orders",
      align: "left",
      margin: 15,
      offsetX: 140,
      offsetY: 10,
      floating: false,
      style: {
        fontSize: "15px",
        fontWeight: "600",
        color: "#263238",
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -10,
        },
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: true,
            offsetY: 60,
          },
        },
      },
    ],
  },
};

export { pieChart };
